import { basePath } from "../common/path";

const path = {
  getDiagnostcByUser: basePath.concat("/diagnostic-log"),
  getCities: "/cities",
  saveHealthCondition: basePath.concat("/health-conditions"),
  getAllHealthCondition: basePath.concat("/health-conditions"),
  detailHealthCondition: basePath.concat("/health-conditions"),
  saveFiles: basePath.concat("/health-conditions"),
  getAllBodyParts: basePath.concat("/health-conditions/body/parts"),
  saveMorbidity: basePath.concat("/health-conditions/morbidity"),
  saveAuthorization: basePath.concat("/health-conditions/authorization"),
  verifyAuthorization: basePath.concat("/health-conditions/morbidity"),
  getMorbidity: basePath.concat("/health-conditions/morbidity"),
  getAllMorbidity: basePath.concat("/health-conditions/morbidity"),
  saveFileAuthorization: basePath.concat("/health-conditions/morbidity/upload/authorization-file"),
  getEmployee: "/coreEmployees",
};
export { path };